import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class StoreTicketReasons extends Component {
    constructor() {
        super()
        this.state = {
            storeTicketReasonsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getDesignationList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getDesignationList = () => {
        apiService.getStoreTicketReasonslList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        storeTicketReasonsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.storeTicketReasonsList).map((value,index) => {
            
            return {
                label : this.state.storeTicketReasonsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Reason"
                options={list}
                onChange={(e) => { (e) ? this.props.storeTicketReasonsChange(e) : this.props.storeTicketReasonsChange([])}}
                />
            </div>
        )
    }
}
export default StoreTicketReasons


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/DropDowns/StoreTicketReasons.js